<template>
  <div>
    <div class="form-inline">
      <div class="form-group">
        <button class="btn btn-outline blue" id="btnUpload" @click.prevent="triggerInput()" data-loading-text="Loading...">
          Ajouter une image &nbsp;
          <i class="far fa-image"></i>
        </button>
      </div>
    </div>
    <div class="images">
      <div v-for="image in images" :key="image.id" class="myOverlay boxShadow" @mouseenter="hover = image.id" @mouseleave="hover = null">
        <img :src="`/${image.optimized}`" class="cover" :alt="image.description">
        <transition name="fade">
          <div class="myOverlay-inner" v-if="hover === image.id">
            <div class="OverlayInnerItems">
              <!-- <div>
                <a class="btn default btn-outline" href="javascript:;">
                  <i class="icon-pencil"></i>
                </a>
              </div> -->
              <div>
                <a class="btn default btn-outline" href="javascript:;" @click="deleteImage(image)">
                  <i class="icon-close"></i>
                </a>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <input type="file" v-if="inputLoaded" class="input-file" :name="name" :ref="`input-file`" @change="processImage()">
  </div>
</template>

<script>
export default {

  name: 'image-multi-upload',
  props: {
    oldImages: {},
    name: '',
    max: '',
    id: ''
  },
  data () {
    return {
      counter: 0,
      images: Object.assign([], this.oldImages),
      image: undefined,
      hovered: null,
      hover: null,
      inputLoaded: true,
      display: {}
    }
  },
  mounted () {
    this.images.map(() => {
      this.counter += 1
    })
  },
  methods: {
    triggerInput () {
      this.$refs['input-file'].click()
    },
    deleteImage (oldImage) {
      var image = new Image(null, this)
      
      image.delete(oldImage)
    },
    processImage () {
      this.image = new Image(this.$refs['input-file'], this)

      this.image.send('portfolio', '/post/image/' + this.id)
    }
  }
};
</script>

<style lang="css" scoped>
.input-file {
  display: none!important;
}
.cover {
  object-fit: cover;
  width: 200px;
  height:200px;
  border: 1px solid rgb(0, 0, 0);
}

.images{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.btn{
  margin-bottom: 2rem
}
.myOverlay-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.808);
}
.OverlayInnerItems{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}
.OverlayInnerItems > div {
  margin: 1em;
}
.myOverlay {
  position: relative;
  width: 200px;
  height:200px;
  margin: .5rem;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
